import { render, staticRenderFns } from "./Moldes.vue?vue&type=template&id=b0b13ba2&"
import script from "./Moldes.vue?vue&type=script&lang=js&"
export * from "./Moldes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports